import React from "react";
import { firebaseConnect } from "react-redux-firebase";
import Spinner from "../../Spinner/Spinner";
import CardCategory from "./components/CardCategory/CardCategoty";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Error from "../../Error/error";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 924 },
    items: 3,
    paritialVisibilityGutter: 60,
  },
  tablet: {
    breakpoint: { max: 924, min: 600 },
    items: 3,
    paritialVisibilityGutter: 50,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 3,
    paritialVisibilityGutter: 0,
  },
};

class ArraysCategory extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      categories: [],
    };
  }
  componentDidMount() {
    const docRef = this.props.firebase
      .firestore()
      .collection("types")
      .where("active", "==", true)
      .orderBy("position", "asc");

    docRef
      .get()
      .then((querySnapshot) => {
        const categories = [];
        querySnapshot.forEach((doc) => {
          const { image, name } = doc.data();
          categories.push({
            id: doc.id,
            image,
            name,
          });
        });
        categories.sort((a, b) => {
          return a.position - b.position;
        });
        if (categories.length) {
          this.setState(() => ({ loading: false, categories, error: false }));
        } else {
          this.setState(() => ({ loading: false, error: true }));
        }
      })
      .catch((error) => {
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    const { categories, loading, error } = this.state;

    let message;
    if (loading === true) {
      message = <Spinner />;
    } else if (error === true) {
      message = <Error />;
    } else {
      message = (
        <div className="pl-4 pr-4">
          <br></br>
          <br></br>
          <div className="text-center pb-5">
            <h2 className="font-weight-bold">Compra por Categoría</h2>
          </div>
          <Carousel
            itemClass="image-item"
            draggable={true}
            swipeable={true}
            autoPlay={true}
            infinite={true}
            responsive={responsive}
            className="carousel z-index"
          >
            {categories.map((array) => (
              <center key={array.id}>
                <CardCategory array={array} />
              </center>
            ))}
          </Carousel>
          ;
        </div>
      );
    }

    return <>{message}</>;
  }
}

export default firebaseConnect()(ArraysCategory);
